import type { ResponseTargetingMode, ScientificConfidenceLevel } from '@brushfire/types'

export type Step4Phase = 'mode_selection' | 'standard_tabs' | 'scientific'

export const DEFAULT_CONFIDENCE_LEVEL: ScientificConfidenceLevel = 0.95
export const DEFAULT_MARGIN_OF_ERROR_PERCENT = 5

export const CONFIDENCE_LEVEL_OPTIONS: ScientificConfidenceLevel[] = [0.9, 0.95, 0.99]

export function resolveStep4Phase(
  targetingMode: ResponseTargetingMode | null | undefined,
): Step4Phase {
  if (targetingMode === 'standard') return 'standard_tabs'
  if (targetingMode === 'scientific') return 'scientific'
  return 'mode_selection'
}

/**
 * Standalone `scientific` phase is No Rewards only.
 * Rewarded scientific uses the budget tab layout (`standard_tabs`) — B618-1.
 * Without this, No Rewards → Scientific → back → Rewards leaves a blank Step 4.
 */
export function reconcileStep4PhaseForRewardEnabled(
  step4Phase: Step4Phase,
  rewardEnabled: boolean,
): Step4Phase {
  if (rewardEnabled && step4Phase === 'scientific') return 'standard_tabs'
  return step4Phase
}

/** Draft resume — rewarded scientific stays in tab layout (B618-1 UX deviation). */
export function resolveHydratedStep4Phase(input: {
  step4Phase?: Step4Phase
  targetingMode?: ResponseTargetingMode | null
  scientificTargetLocked?: boolean
  rewardEnabled: boolean
}): Step4Phase {
  if (input.step4Phase) {
    return reconcileStep4PhaseForRewardEnabled(input.step4Phase, input.rewardEnabled)
  }
  if (!input.targetingMode) return 'mode_selection'
  if (input.scientificTargetLocked) return 'standard_tabs'
  if (input.targetingMode === 'standard') return 'standard_tabs'
  if (input.targetingMode === 'scientific' && input.rewardEnabled) return 'standard_tabs'
  return 'scientific'
}

export function confidenceLevelLabel(level: ScientificConfidenceLevel): string {
  return `${Math.round(level * 100)}%`
}

export function formatEligibleSpCount(count: number): string {
  return count.toLocaleString()
}
